import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, change, FieldArray } from "redux-form";
import { BaseComponent } from "BaseComponent";
import { showError, showSuccess } from "ReduxErrorBar";
import Button from "react-bootstrap-button-loader";
import _ from "lodash";
import {
  openLanguageAddModal,
  fetchEventLanguages,
  updateEventLanguage,
  openLanguageCsvImportModal,
} from "SettingActions";
import { COMMON_FAIL_MESSAGE, screenHeightLeftFromTop } from "Constants";
import AddNew from "./add-new";
import ImportCSV from "./import-csv";
import LocaleStrings from "Languages";

class Language extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      validated: false,
      files: [],
      processingData: false,
      hasData: false,
      importedusers: [],
      hasError: false,
      hasDataError: false,
      errorMessage: "",
      fileData: [],
      isEnabled: false,
      langId: null,
      enableChanging: false,
      search: "",
    };
  }

  componentDidMount() {
    this.props.fetchEventLanguages(this.props.session, (response) => {
      if (response.success && response.data && response.data.length > 0) {
        //console.log("response.data", response.data);
        var checkValue = _.filter(response.data, function (opt) {
          return opt.languagekey == "en";
        });

        if (checkValue.length > 0) {
          this.reloadParent(checkValue);
        }
      }
    });
  }

  openModal() {
    this.props.autofill("languagearray", []);
    this.props.autofill("languagekey", "");
    this.setState({
      fileData: [],
      processingData: false,
      hasData: false,
      langId: null,
    });
    this.props.openLanguageAddModal(true);
  }

  reloadParent = (checkValue) => {
    //console.log("lang", checkValue);
    // this.props.autofill("languagearray", []);
    // this.props.autofill("languagekey", "");
    // this.setState({
    //   fileData: [],
    //   processingData: false,
    //   hasData: false,
    //   langId: null,
    // });

    let id = checkValue[0].id;
    this.props.autofill("languagekey", id);
    this.setState({ langId: id });

    if (checkValue[0].languagejson) {
      let modifiedArr = [];
      let languagejson = JSON.parse(checkValue[0].languagejson);
      _.map(languagejson, (obj, index) => {
        let jsonObj = {};
        jsonObj.key = index;
        jsonObj.value = languagejson[index];
        modifiedArr.push(jsonObj);
      });

      this.setState({
        fileData: modifiedArr,
        hasData: true,
        processingData: true,
        isEnabled: checkValue[0].isenabled == 1 ? true : false,
      });

      this.props.dispatch(change("LanguageForm", "languagearray", modifiedArr));
    } else {
      this.props.dispatch(change("LanguageForm", "languagearray", []));
      this.setState({
        fileData: [],
        processingData: false,
        hasData: false,
      });
    }
  };

  onSubmitForm = (data) => {
    let { eventLanguages } = this.props;

    let newdata = {};
    let languagearray = data.languagearray;
    // console.log("languagearray :- ", languagearray);

    var checkValue = _.filter(eventLanguages, function (opt) {
      return opt.id == data.languagekey;
    });
    let originalJson = JSON.parse(checkValue[0].languagejson);

    for (const key in originalJson) {
      let match = _.filter(languagearray, (o) => {
        return o.key === key;
      });

      if (match.length > 0) {
        originalJson[key] = match[0].value;
      }
    }
    // console.log("originalJson after :- ", originalJson);

    newdata.languagejson = JSON.stringify(originalJson);
    newdata.id = data.languagekey;
    newdata.isenabled = this.state.isEnabled ? 1 : 0;

    // console.log("Final values :- ", newdata);

    this.setState({ loading: true });
    this.props.updateEventLanguage(this.props.session, newdata, (response) => {
      //console.log("response", response);
      if (response.success === 0) {
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.props.fetchEventLanguages(this.props.session, (feedback) => {
          if (feedback.success === 1) {
            this.props.showSuccess(LocaleStrings.language_updated_message);
            this.setState({ loading: false });
          }
        });
      }
    });
  };

  renderList = ({ fields, speakers }) => {
    return fields.map((speaker, index) => {
      let currentIndexData = fields.get(index);
      return currentIndexData.value ? (
        <tr key={`KEY-${index}`}>
          <td>
            <Field
              name={`${speaker}.value`}
              label={currentIndexData.key}
              type="text"
              component={this.renderFieldText}
              mandatory="false"
            />
          </td>
        </tr>
      ) : (
        <tr key={`KEY-${index}`}>
          <th>{currentIndexData.key}</th>
        </tr>
      );
    });
  };

  handleIsEnabled = () => {
    this.setState({ enableChanging: true });
    let isEnabled = !this.state.isEnabled;
    let newdata = {};
    newdata.id = this.state.langId;
    newdata.isenabled = isEnabled ? 1 : 0;
    this.props.updateEventLanguage(this.props.session, newdata, (response) => {
      if (response.success) {
        this.setState({ enableChanging: false, isEnabled: isEnabled });
      } else {
        this.setState({ enableChanging: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  _handleLanguageSel = (e) => {
    let value = e.target.value;

    this.setState({ langId: value });
    var checkValue = _.filter(this.props.eventLanguages, function (opt) {
      return opt.id == value;
    });

    if (checkValue.length > 0) {
      if (checkValue[0].languagejson) {
        let modifiedArr = [];
        let languagejson = JSON.parse(checkValue[0].languagejson);
        _.map(languagejson, (obj, index) => {
          let jsonObj = {};
          jsonObj.key = index;
          jsonObj.value = languagejson[index];
          modifiedArr.push(jsonObj);
        });

        this.setState({
          fileData: modifiedArr,
          hasData: true,
          processingData: true,
        });

        this.props.dispatch(
          change("LanguageForm", "languagearray", modifiedArr)
        );
      } else {
        this.props.dispatch(change("LanguageForm", "languagearray", []));
        this.setState({
          fileData: [],
          processingData: false,
          hasData: false,
        });
      }
      this.setState({ isEnabled: checkValue[0].isenabled == 1 ? true : false });
    } else {
      this.props.dispatch(change("LanguageForm", "languagearray", []));
      this.setState({
        fileData: [],
        processingData: false,
        hasData: false,
      });
    }
  };

  onSearchText = (event) => {
    let { eventLanguages } = this.props;
    var { langId } = this.state;
    var search = event.target.value;
    // console.log("eventLanguages :- ", eventLanguages);
    // console.log("langId :- ", langId);

    var checkValue = _.filter(eventLanguages, function (opt) {
      return opt.id == langId;
    });

    let originalJson = [];
    if (checkValue.length > 0) {
      originalJson = JSON.parse(checkValue[0].languagejson);
    }

    let originalLanguageArr = [];
    _.map(originalJson, (obj, index) => {
      let jsonObj = {};
      jsonObj.key = index;
      jsonObj.value = originalJson[index];
      originalLanguageArr.push(jsonObj);
    });

    let modifiedArr = [];
    if (search != "") {
      modifiedArr = originalLanguageArr.filter(
        (opt) =>
          opt.key.toLowerCase().includes(search.toLowerCase()) ||
          opt.value.toLowerCase().includes(search.toLowerCase())
      );

      this.props.dispatch(change("LanguageForm", "languagearray", modifiedArr));
    } else {
      modifiedArr = originalLanguageArr;
      this.props.dispatch(change("LanguageForm", "languagearray", modifiedArr));
    }

    this.setState({ search, fileData: modifiedArr });
  };

  render() {
    var {
      handleSubmit,
      invalid,
      pristine,
      submitting,
      deviceSize,
      eventLanguages,
    } = this.props;

    var {
      filepath,
      fileData,
      processingData,
      hasData,
      hasError,
      hasDataError,
      errorMessage,
      isEnabled,
      langId,
      enableChanging,
      search,
    } = this.state;

    var hideDropZoneClass = "";
    var hideControlButton = "hide-feature";

    if (filepath && filepath !== "file object not found") {
      hideDropZoneClass = "hide-feature";
      hideControlButton = "";
    }

    let langArray = [];
    let obj = {
      name: LocaleStrings.language_setting_form_select_language,
      value: "",
    };
    langArray.push(obj);
    if (eventLanguages && eventLanguages.length > 0) {
      eventLanguages.map((object, index) => {
        let obj = {
          name: _.startCase(object.languagetext),
          value: object.id,
        };
        langArray.push(obj);
      });
    }

    // console.log("langArray", langArray);
    return (
      <>
        <div className="row ticket-dashboard panel-body">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <form onSubmit={handleSubmit(this.onSubmitForm)}>
              <div>
                <div className="">
                  <h4>{LocaleStrings.language_setting_heading}</h4>
                </div>
                <div
                  className="ticket-dashboard-ticket-sell-main-div"
                  style={{ height: "auto" }}
                >
                  <div className="col-lg-4 col-sm-3 col-md-4 col-xs-6 ">
                    <Field
                      name="languagekey"
                      component={this.renderSelect}
                      opts={langArray}
                      onChange={this._handleLanguageSel}
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-md-3 col-xs-6 ">
                    <Button
                      bsStyle=""
                      className="btn-custom-blue schedule-add-button"
                      onClick={() => this.openModal()}
                    >
                      <img
                        style={{ paddingRight: 10 }}
                        src="../../style/images/header-icons/plus.png"
                      ></img>
                      {LocaleStrings.language_setting_form_add_language}
                    </Button>
                  </div>
                  <div className="col-lg-4 col-sm-3 col-md-4 col-xs-6 vertical-align-center">
                    {langId ? (
                      <>
                        <div>
                          <label
                            className="switch-button-container"
                            style={{ marginRight: 0 }}
                          >
                            <input
                              type="checkbox"
                              onChange={
                                enableChanging ? null : this.handleIsEnabled
                              }
                              checked={isEnabled}
                            />
                            <span
                              className={`switch-slider switch-round ${
                                enableChanging ? "cursor-wait" : ""
                              }`}
                            ></span>
                          </label>
                        </div>
                        <div className="pl-12">
                          <div style={{ fontSize: 14, fontWeight: 500 }}>
                            {isEnabled
                              ? LocaleStrings.language_setting_isenabled
                              : LocaleStrings.language_setting_isdisabled}
                          </div>
                          <div>
                            {isEnabled
                              ? LocaleStrings.language_setting_isdisabled_message
                              : LocaleStrings.language_setting_isenbled_message}
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {langId ? (
                  <>
                    <div className="pt-20">
                      <h4>{LocaleStrings.language_setting_edit}</h4>
                    </div>
                    <div className="vertical-align-center-justify-between">
                      <div className="col-lg-6 col-sm-12 col-md-6 col-xs-12 ">
                        <div>{LocaleStrings.language_manual_text}</div>
                        <div>
                          {LocaleStrings.language_bulk_text}{" "}
                          <span
                            className="pointer import-option-button"
                            style={{ fontWeight: "bold" }}
                            onClick={() =>
                              this.props.openLanguageCsvImportModal(true)
                            }
                          >
                            {LocaleStrings.language_import_text}
                          </span>
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-12 col-md-6 col-xs-12">
                        <div className="row">
                          <div className="col-lg-4 col-sm-12 col-md-4 col-xs-12">
                            <Button
                              loading={this.state.loading}
                              type="submit"
                              //disabled={pristine || invalid || submitting}
                              className="btn btn-custom-blue w-100"
                            >
                              {LocaleStrings.button_save}
                            </Button>
                          </div>
                          <div className="col-lg-8 col-sm-12 col-md-8 col-xs-12">
                            <input
                              className="form-control mapsearch"
                              placeholder={`${LocaleStrings.button_search_keyword} `}
                              type="text"
                              value={search}
                              onChange={this.onSearchText}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {fileData.length > 0 ? (
                      <div
                        className="row"
                        style={{
                          height:
                            deviceSize.height - (screenHeightLeftFromTop + 168),
                          background: "#fff",
                          border: "1px solid #E6EDF3",
                          marginTop: 16,
                          borderRadious: 8,
                        }}
                      >
                        <div className="col-lg-12 col-md-12 imported-users">
                          <table className="table language-table">
                            <tbody>
                              <FieldArray
                                name="languagearray"
                                component={this.renderList}
                              />
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
            </form>
          </div>
        </div>
        <AddNew reloadParent={this.reloadParent} />
        <ImportCSV
          langId={this.state.langId}
          reloadParent={this.reloadParent}
        />
      </>
    );
  }
}

function validate(values) {
  var errors = {};

  if (!values.languagekey) {
    errors.languagekey =
      LocaleStrings.language_setting_form_select_language_error;
  }

  return errors;
}

function mapStateToProps(state) {
  return {
    session: state.session,
    user: state.user,
    deviceSize: state.deviceSize,
    eventLanguages: state.eventLanguages,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openLanguageAddModal,
  fetchEventLanguages,
  updateEventLanguage,
  openLanguageCsvImportModal,
})(
  reduxForm({
    form: "LanguageForm",
    validate,
    /*asyncValidate,
      asyncBlurFields:['oldpwd'],*/
    enableReinitialize: true,
  })(Language)
);
